<template>
  <van-notice-bar
    left-icon="volume-o"
    mode="closeable"
    color="#1989fa"
    background="#ecf9ff"
    >点击可查看图片</van-notice-bar
  >
  <div class="cell-group">
    <van-cell-group inset>
      <van-cell v-if="rank.length === 0">
        <van-empty class="custom-image" description="无排行榜内容" />
      </van-cell>
      <van-cell
        class="custom-cell"
        v-for="(item, index) in rank"
        :key="index"
        @click="imgClick(item)"
      >
        <template #title>
          <div class="cell-title">
            <van-tag
              class="cell-tag"
              v-if="item.order == 1"
              size="medium"
              type="danger"
              >排名1</van-tag
            >
            <van-tag
              class="cell-tag"
              v-if="item.order == 2 || item.order == 3"
              size="medium"
              type="warning"
              >排名{{ item.order }}</van-tag
            >
            <van-tag
              class="cell-tag"
              v-if="item.order > 3"
              size="medium"
              plain
              type="primary"
              >排名{{ item.order }}</van-tag
            >
            <span class="custom-title"
              >{{ item.candidate.name }}: {{ item.candidate.title }}
              <span class="cell-records">({{ item.records }}票)</span></span
            >
          </div>
        </template>
        <!-- <template #label>
          <div class="van-multi-ellipsis--l3 custom-label">
            {{ item.candidate.solgan }}
          </div>
        </template> -->
      </van-cell>
    </van-cell-group>
  </div>
  <div class="bottom"></div>
</template>

<script>
import {
  Cell,
  CellGroup,
  Tag,
  Image as VanImage,
  Empty,
  NoticeBar,
  ImagePreview,
} from "vant";
import { computed } from "vue";
import { useStore } from "vuex";
// import { useRoute } from "vue-router";
export default {
  name: "RankList",
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [VanImage.name]: VanImage,
    [Empty.name]: Empty,
    [NoticeBar.name]: NoticeBar,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  setup() {
    const store = useStore();

    const imgClick = (item) => {
      console.log(item.candidate.image);
      const images = Array(item.candidate.image);
      ImagePreview({
        images: images,
        closeable: true,
      });
    };

    return {
      imgClick,
      rank: computed(() => store.state.rank),
    };
  },
  created() {
    const { aplus_queue } = window;
    aplus_queue.push({
      action: "aplus.sendPV",
      arguments: [
        {
          is_auto: false,
        },
        {
          param: "ranklist",
        },
      ],
    });
  },
};
</script>

<style lang="scss" scoped>
.cell-group {
  padding: 20px 0;
  background-color: $light-gray;
}
.custom-cell {
  --van-cell-font-size: 14px;
  padding: 15px 20px;
}
.cell-title {
  display: flex;
  align-items: baseline;
}
.cell-tag {
  flex-shrink: 0;
  margin-right: 10px;
}
.cell-records {
  color: $dark-gray;
  // font-size: 4vw;
}
.custom-title {
  margin-left: 10px;
  text-align: left;
  font-size: 4vw;
  font-weight: 600;
}
.cell-value {
  text-align: left;
}
// .cell-text-box {
//   display: flex;
//   justify-content: space-between;
//   margin-bottom: 6px;
// }
.bottom {
  width: 100%;
  height: env(safe-area-inset-bottom);
  background-color: $light-gray;
}
// .custom-label {
//   font-size: 3.8vw;
//   text-align: left;
// }
</style>
